import React from 'react';

function LegacyLoginPanel(props) {
    if (!props.code) return null;
    return React.createElement('div', { className: 'container mt-3' },
        React.createElement('div', { className: 'bb-legacy-login' },
            React.createElement('h5', null, 'Link Discord on another device'),
            React.createElement('p', null, 'Scan to open login on a modern device, then complete Discord login.'),
            React.createElement('div', { className: 'bb-legacy-qr' },
                React.createElement('img', {
                    src: props.qrData || '',
                    alt: 'Login QR'
                })
            ),
            React.createElement('p', { className: 'bb-legacy-note' }, 'Code: ' + props.code + ' — will auto-complete here after login.')
        )
    );
}

export default LegacyLoginPanel;
